import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import {
  getRaceDistanceFract,
  getRaceDistanceUnitDesignation,
  SHORT_DISTANCE_THRESHOLD_IN_FURLONGS
} from "utils/distance-utils";

export const DATA_TESTID_ABOUT_INDICATOR = "about-indicator";
export const DATA_TESTID_INT = "int";
export const DATA_TESTID_FRACT = "fract";
export const DATA_TESTID_DISTANCE = "distance";
export const DATA_TESTID_UNIT = "unit";

interface IProps {
  distance: number;
  unit: racehorse360.DistanceUnit;
  showAboutDistanceIndicator?: boolean;
}

const RaceDistance = (props: IProps) => {
  const { distance, unit, showAboutDistanceIndicator = false } = props;

  const renderAboutDistanceIndicator = () => {
    if (!showAboutDistanceIndicator) return;

    return <span data-testid={DATA_TESTID_ABOUT_INDICATOR}>{"*"}</span>;
  };

  const renderDistance = () => {
    if (unit === racehorse360.DistanceUnit.DISTANCE_UNIT_FURLONG) {
      const int =
        distance < SHORT_DISTANCE_THRESHOLD_IN_FURLONGS
          ? Math.trunc(distance / 100)
          : Math.trunc(distance / SHORT_DISTANCE_THRESHOLD_IN_FURLONGS);
      const frac = getRaceDistanceFract(distance);

      return (
        <>
          {Boolean(int) && <span data-testid={DATA_TESTID_INT}>{int}</span>}
          {Boolean(frac) && <sup data-testid={DATA_TESTID_FRACT}>{frac}</sup>}
        </>
      );
    } else {
      return <span data-testid={DATA_TESTID_DISTANCE}>{distance}</span>;
    }
  };

  const renderRaceDistanceUnit = () => {
    const unitDesignation = getRaceDistanceUnitDesignation(distance, unit);

    return (
      unitDesignation && (
        <span data-testid={DATA_TESTID_UNIT}>{unitDesignation}</span>
      )
    );
  };

  return (
    <>
      {renderAboutDistanceIndicator()}
      {renderDistance()}
      {renderRaceDistanceUnit()}
    </>
  );
};

export default React.memo(RaceDistance);
